let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3iNiV")).then(() => parcelRequire('7pxIK'));